module.exports = __webpack_public_path__ + "static/media/funnelkonnekt-6_preview (1).3c5e61b5.png";